<template>
  <v-dialog v-model="isActive" max-width="700">
    <v-card>
      <v-card-title v-show="showCardTitle">
        <slot name="header" />
      </v-card-title>
      <v-card-text>
        <slot name="content" />
        <slot name="error">
          <v-alert v-if="props.errorMessage" class="mt-2" type="error">
            {{ props.errorMessage }}
          </v-alert>
        </slot>
      </v-card-text>
      <v-card-actions v-show="showCardActions">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useSlots } from 'vue'

type CommonDialogProps = {
  errorMessage?: string | null
}
const slots = useSlots()
const showCardActions = slots.actions !== undefined
const showCardTitle = slots.header !== undefined

const isActive = defineModel<boolean>('isActive')

const props = withDefaults(defineProps<CommonDialogProps>(), {
  errorMessage: null,
})
</script>
